import {
  type AndCondition,
  type AndOrCondition,
  type Condition,
  ConditionType,
  type OrCondition,
} from "src/types/visual";

export const isAndOrCondition = <TCondition extends Condition>(
  condition: AndOrCondition<TCondition> | undefined | symbol,
): condition is AndCondition<TCondition> | OrCondition<TCondition> => {
  if (!condition || typeof condition === "symbol") {
    return false;
  }

  return (
    condition.type === ConditionType.And || condition.type === ConditionType.Or
  );
};
